"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workForm = void 0;
const enums_1 = require("@bemlo/enums");
exports.workForm = {
    [enums_1.WorkForm.ENTREPRENEUR]: 'Sub-consultant at an own company',
    [enums_1.WorkForm.HOURLY_WORKER]: 'Hourly worker',
    [enums_1.WorkForm.OPEN_TO_BOTH]: 'Sub-consultant or hourly worker',
};
